import gql from 'graphql-tag';

const mutateLogout = gql`
  mutation {
    logout {
      data
      errors
      oktaLogoutUrl
    }
  }
`;

export default mutateLogout;
